import React, { ReactNode, useContext, useState, useEffect } from 'react'
import { eventBus } from 'src/helper/EventBus'
import { itemServices } from 'src/services/reservation/item/item.service'
type BillingInfo = {
  [key: string]: {
    automatic: Boolean | null
    billable_status: string
  }
}

type ReservationInfo = {
  billing_info?: BillingInfo
}

type ReservationInfoContextState = {
  reservationInfo: ReservationInfo
  setReservationInfo: (info: ReservationInfo) => void
  openDueDateModal: boolean
  setOpenDueDateModal: (state: boolean) => void
}

const ReservationInfoContext = React.createContext<ReservationInfoContextState | undefined>(undefined)

export const useReservationInfo = () => {
  const context = useContext(ReservationInfoContext)
  if (!context) {
    throw new Error('useReservationInfo must be used within a ReservationInfoProvider')
  }
  return context
}

type ReservationInfoProviderProps = {
  children: ReactNode
}

export const ReservationInfoProvider: React.FC<ReservationInfoProviderProps> = ({ children }) => {
  const [reservationInfo, setReservationInfo] = useState<ReservationInfo>({})
  const [openDueDateModal, setOpenDueDateModal] = useState(false)

  const updateReservationInfo = (info: ReservationInfo) => {
    setReservationInfo(info)
  }

  useEffect(() => {
    const handleUpdateBillingStatus = async (event: CustomEvent<string>) => {
      const hash = event.detail

      if (!hash) return

      try {
        const billing = await itemServices.get_billing_status(hash)
        setReservationInfo((prevInfo) => {
          const newBillingInfo = { ...prevInfo.billing_info, [hash]: billing }
          return { ...prevInfo, billing_info: newBillingInfo }
        })
      } catch (error) {
        console.error('Error fetching billing status:', error)
      }
    }

    // Suscribir el listener al evento 'updateBillingStatus'
    eventBus.on<string>('updateBillingStatus', handleUpdateBillingStatus)


    return () => {
      // Desuscribirse al desmontar
      eventBus.off<string>('updateBillingStatus', handleUpdateBillingStatus)
    }
  }, [])

  return (
    <ReservationInfoContext.Provider
      value={{
        reservationInfo,
        setReservationInfo: updateReservationInfo,
        openDueDateModal,
        setOpenDueDateModal,
      }}
    >
      {children}
    </ReservationInfoContext.Provider>
  )
}
